import React from 'react';
import mcnairheadshot from '../image (23).png'
import williamheadshot from '../WP_Headshot.jpg'
const About = () => {
  return (
    <div className="container-fluid text-dark p-5" style={{ backgroundColor: '#E6EBF0' }}>
      <h2 className="text-center mb-4">About Us</h2>
      <div className="row">
        <div className="col-md-6">
          <div className="card mb-4 text-center">
            <img src={williamheadshot} className="rounded-circle mx-auto d-block mt-4" style={{ width: '150px', height: '150px', objectFit: 'cover' }} alt="Consultant 1" />
            <div className="card-body">
              <h5 className="card-title">William Peng</h5>
          <p className="card-text">William is an incoming freshman at Stanford University studing Biology and Computer Science. He has high-level experience in academic competitions including chemistry olympiad (USNCO), biology olympiad (USABO), science fair (ISEF finalist), science bowl, science olympiad, and others. His experience with pre-med and liberal arts will help aspiring students achieve their full potential!</p>
          <h6>College Results</h6> 
          <ul className="list-unstyled">
          <li>Stanford University</li>
          <li>Princeton University</li>
          <li>Yale University (accepted early)</li>
          <li>Brown University - Program in Liberal Medical Education (PLME)</li>
          <li>Emory University (Woodruff Scholar finalist)</li>
          <li>University of Alabama at Birmingham - Early Medical Acceptance Program (EMSAP)</li>
          <li>...and others!</li>
          </ul>
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="card mb-4 text-center">
            <img src={mcnairheadshot} className="rounded-circle mx-auto d-block mt-4" style={{ width: '150px', height: '150px', objectFit: 'cover' }} alt="Consultant 2" />
            <div className="card-body">
              <h5 className="card-title">McNair Shah</h5>
              <p className="card-text">McNair is an incoming Computer Science Freshman at Carnegie Mellon. He has high-level experience in academic competitions including math olympiads, physics olympiads, chemistry olympiads, science bowl, science olympiad, FIRST robotics, Research, and others. His experience will help your student reach their STEM potential both in their application season and before!</p>
              <h6>College Results</h6>
              <ul className="list-unstyled">
                <li>Carnegie Mellon Univeristy</li>
                <li>California Institute of Technology (accepted early)</li>
                <li>Georgia Institute of Technology</li>
                <li>University of Illinois at Urbana-Champaign</li>
                <li>University of Michigan Ann-Arbor</li>
                <li>University of Wisconsin-Madison</li>
                <li>...and others!</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
